import { AssignmentTurnedIn, Category, Dashboard, EventNote, ExpandLess, ExpandMore, Fingerprint, Home, InsertDriveFile, ManageAccounts, SettingsApplications, ViewModule, Window } from '@mui/icons-material';
import IconeMovimentosCnj from '../img/icones/IconeMovimentosCnj';
import BuildIcon from '@mui/icons-material/Build';
import { Collapse, ListItemButton } from '@mui/material';
import Divider from '@mui/material/Divider';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import { CSSObject, Theme, styled } from '@mui/material/styles';
import { action, computed, observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import EscaninhoGabinete from '../img/icones-menu-lateral/EscaninhoGabinete';
import EscaninhoJulgamento from '../img/icones-menu-lateral/EscaninhoJulgamento';
import EscaninhoJustificativa from '../img/icones-menu-lateral/EscaninhoJustificativa';
import EscaninhoPeticoes from '../img/icones-menu-lateral/EscaninhoPeticoes';
import EscaninhoRedator from '../img/icones-menu-lateral/EscaninhoRedator';
import EscaninhoUsuario from '../img/icones-menu-lateral/EscaninhoUsuario';
import EscaninhoVistos from '../img/icones-menu-lateral/EscaninhoVistos';
import IcondeEstruturas from '../img/icones/IcondeEstruturas';
import IconeAM from '../img/icones/IconeAM';
import IconeAutotexto from '../img/icones/IconeAutotexto';
import IconeGE from '../img/icones/IconeGE';
import IconeTemas from '../img/icones/IconeTemas';
import UsuarioStore from '../store/UsuarioStore';
import FiltroStore from '../store/FiltroStore';
import LayoutStore from '../store/LayoutStore';
import RouterStore from '../store/RouterStore';
import TopBarStore from '../store/TopBarStore';
import Configuracao from '../utils/Configuracao';
import JustDev from '../utils/JustDev';
import { itensMenuPermitidos } from './MenuAcessoRapidoItens';
import './css/drawer.css';


const drawerWidth = 450;

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: TopBarStore.menuAberto ? 'flex-end' : 'flex-start',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));


const openedMixin = (theme: Theme): CSSObject => ({
    position: 'static',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    position: 'static',
    width: `calc(${theme.spacing(9)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(10)} + 1px)`,
    },
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
});


const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    height: '100%',
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    position: 'static',
    ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
    }),
}));

interface IPropsMenuPrincipal {

}


class MenuPrincipalPopper extends React.Component<IPropsMenuPrincipal> {
    open = TopBarStore.menuAberto;
    openSubmenu = true;
    openSecondLevel = false;
    expand = false;

    setOpen = value => { this.open = value; };

    handleDrawerOpen = (event) => {
        TopBarStore.abreMenu(event);
        FiltroStore.drawerIsOpen = false;
        this.setOpen(true);
    };

    handleDrawerClose = () => {
        TopBarStore.fechaMenu();
        this.setOpen(false);
    };

    constructor(props: IPropsMenuPrincipal) {
        super(props);

        makeObservable(this, {
            open: observable,
            openSubmenu: observable,
            openSecondLevel: observable,
            expand: observable,
            setOpen: action,
            handleDrawerOpen: action,
            handleDrawerClose: action,
            usuario: computed,
            handleClick: action
        });
    }

    get usuario() {
        return UsuarioStore.usuario;
    }

    irEndereco = (endereco, event) => {
        event.preventDefault();
        RouterStore.push(endereco);
        this.handleDrawerClose();
    }

    alternaMenu = (event) => {
        this.open ? this.handleDrawerClose() : this.handleDrawerOpen(event);
    }

    isItemSelecionado = (endereco) => {
        return RouterStore.rotaAtual === endereco
            || (endereco === '/telaPrincipal' && RouterStore.rotaAtual === '/');
    }

    itemMenu = (texto, endereco, icone) => {
        const isSelected = this.isItemSelecionado(endereco);
        return (
            <ListItemButton style={{ height: '48px', borderLeft: 'solid 5px', borderLeftColor: isSelected ? 'rgb(1, 87, 155)' : 'transparent', marginLeft: '6px', marginBottom: '3.9px', marginTop: '3.8px', cursor: 'pointer' }}
                onClick={this.irEndereco.bind(this, endereco)}
                title={texto}
                aria-label={texto}>
                <ListItemIcon >
                    <div style={{ color: LayoutStore.colorIcon }}>
                        {icone}
                    </div>
                </ListItemIcon>
                <span style={{ marginLeft: '5px' }}>
                    {texto}
                </span>
            </ListItemButton>
        )
    }

    handleClick = () => {
        this.expand = !this.expand;
    };

    renderGE = () => {
        const rotasPermitidas = new Set(itensMenuPermitidos().map(item => item.route));
        const escaninhosSelecionado = [
            '/escaninho/usuario',
            '/escaninho/gerencial',
            '/escaninho/vistos',
            '/escaninho/julgamento',
            '/escaninho/peticao',
            '/escaninho/redator-designado',
            '/escaninho/voto-vencido'
        ].includes(RouterStore.rotaAtual);
        return (
            <>
                {this.itemMenu('Inicio', '/telaPrincipal', <Home />)}
                {this.itemMenu('Controle do Gabinete', '/controleGabinete', <ViewModule />)}
                <ListItemButton onClick={this.handleClick} style={{ height: '48px', borderLeft: 'solid 5px', borderLeftColor: escaninhosSelecionado ? 'rgb(1, 87, 155)' : 'transparent', marginLeft: '6px', marginBottom: '3.9px', marginTop: '3.8px', cursor: 'pointer' }}>
                    <ListItemIcon sx={{ color: LayoutStore.colorIcon }}>
                        <EventNote />
                    </ListItemIcon>
                    <span style={{ marginLeft: '5px' }}>
                        Escaninhos
                    </span>
                    {this.expand ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={this.expand} timeout="auto" unmountOnExit sx={{ backgroundColor: LayoutStore.isTemaDark ? '#171717' : '#ECECEC' }}  aria-label='Abrir lista de escaninhos'>
                    <List component="div"  aria-label='Abrir lista de escaninhos'>
                        {rotasPermitidas.has('/escaninho/usuario') && this.itemMenu('Usuário', '/escaninho/usuario', <EscaninhoUsuario />)}
                        {rotasPermitidas.has('/escaninho/gerencial') && this.itemMenu('Gabinete', '/escaninho/gerencial', <EscaninhoGabinete />)}
                        {rotasPermitidas.has('/escaninho/vistos') && this.itemMenu('Vistos', '/escaninho/vistos', <EscaninhoVistos />)}
                        {rotasPermitidas.has('/escaninho/julgamento') && this.itemMenu('Julgamento', '/escaninho/julgamento', <EscaninhoJulgamento />)}
                        {rotasPermitidas.has('/escaninho/peticao') && this.itemMenu('Petições', '/escaninho/peticao', <EscaninhoPeticoes />)}
                        {rotasPermitidas.has('/escaninho/redator-designado') && this.itemMenu('Redator Designado', '/escaninho/redator-designado', <EscaninhoRedator />)}
                        {rotasPermitidas.has('/escaninho/voto-vencido') && this.itemMenu('Justificativa de Votos Vencidos', '/escaninho/voto-vencido', <EscaninhoJustificativa />)}
                    </List>
                </Collapse>
                {this.itemMenu('Categorias de Minutas', '/categoria', <Category />)}
                {this.itemMenu('Modelos de Minutas', '/modelosMinuta', <InsertDriveFile />)}
                {(UsuarioStore.usuarioTemPapel(Configuracao.PERFIL_ASSESSOR) || UsuarioStore.ehMagistrado) &&
                    this.itemMenu('Assinatura', '/escaninho/assinatura', <Fingerprint />)
                }
                {(UsuarioStore.usuarioTemPapel(Configuracao.PERFIL_ASSESSOR) || UsuarioStore.ehMagistrado) &&
                    this.itemMenu('Gerenciador de Acervo', '/escaninho/dashboard', <Dashboard />)
                }
                {this.itemMenu('Hermes', '/assistenteMinutas', <IconeAM />)}
                {this.itemMenu('Minutas Assinadas', '/minutasAssinadas', <AssignmentTurnedIn />)}
                {UsuarioStore.usuarioTemPapel(Configuracao.SUPER_ADMINISTRADOR) &&
                    this.itemMenu('Parâmetros do Sistema', '/parametroSistema', <SettingsApplications />)
                }
                {UsuarioStore.usuarioTemPapel(Configuracao.SUPER_ADMINISTRADOR) &&
                    this.itemMenu('Movimentos CNJ', '/movimentosCnj', <IconeMovimentosCnj width={42} height={24} style={{ marginLeft: '-4px' }} />)
                }
                {UsuarioStore.usuarioTemPapel(Configuracao.SUPER_ADMINISTRADOR) &&
                    this.itemMenu('Configurar Parâmetros', '/parametroGabinete', <BuildIcon />)
                }
                {this.itemMenu('Configurar Parâmetros do Usuário', '/parametroUsuario', <ManageAccounts />)}
            </>
        );
    }

    renderHermes = () => {
        return (
            <>
                {this.itemMenu('Inicio', '/assistenteMinutas', <Home />)}
                {this.itemMenu('Temas', '/assistenteMinutas/temas', <IconeTemas />)}
                {this.itemMenu('Modelos de Temas', '/assistenteMinutas/modelosTemas', <InsertDriveFile />)}
                {this.itemMenu('Estruturas', '/assistenteMinutas/estruturas', <IcondeEstruturas />)}
                {this.itemMenu('Autotexto', '/assistenteMinutas/autotextos', <IconeAutotexto />)}
                {this.itemMenu('Gerenciador de Minutas', '/assistenteMinutas/gerenciarMinutas', <Window />)}
                {this.itemMenu('Gabinete Eletrônico', '/telaPrincipal', <IconeGE />)}
            </>
        );
    }

    render() {

        return (

            <Drawer
                open={true}
                onClose={TopBarStore.fechaMenu}
                variant="permanent"
            >

                <div id='drawer' className='esconderImpressao barraLateralMinWidth barraLateralResolucao' style={{ minHeight: '43px' }}>
                    <JustDev >
                        <List>
                            {!RouterStore.isAM ?
                                this.renderGE()
                                :
                                this.renderHermes()
                            }
                            {/* {this.itemMenu('Sobre o GE', '/sobre', <FreeBreakfast />)} */}
                        </List>
                        <Divider />
                        <Divider />
                    </JustDev>
                </div>
            </Drawer>

        );
    }
}

export default observer(MenuPrincipalPopper);
